import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertService } from '@ddv/common-components';
import { QueryParamsService } from '@ddv/filters';
import { Client, DashboardPreference, WidgetFilterParams } from '@ddv/models';

@Component({
    selector: 'ddv-action-icons',
    templateUrl: './action-icons.component.html',
    styleUrls: ['./action-icons.component.scss'],
    standalone: false,
})
export class ActionIconsComponent {
    @Input() clientCode: string | undefined;
    @Input() params: DashboardPreference | WidgetFilterParams | undefined;
    @Input() isTFLDetails = false;

    @Output() handleAcknowledge = new EventEmitter<void>();
    @Output() handleResubmit = new EventEmitter<void>();

    showAcknowledged = false;
    uploadModalOpened = false;

    constructor(
        private readonly alertService: AlertService,
        private readonly queryParamsService: QueryParamsService,
    ) { }

    toggleUploadModal(): void {
        if ((this.params as DashboardPreference)?.clients?.length === 1) {
            this.uploadModalOpened = !this.uploadModalOpened;
        } else {
            this.alertService.warn('Upload is allowed for one client only. Please select a client');
        }
    }

    getClient(): Client | undefined {
        return (this.params as DashboardPreference)?.clients?.[0];
    }

    closeUploadModal(outcome: string): void {
        this.uploadModalOpened = false;

        if (outcome === 'Success') {
            this.alertService.success('Trade Uploaded successfully');
        } else if (outcome === 'Failed') {
            this.alertService.error('Upload failed');
        }
    }

    toggleAcknowledgement(event: boolean): void {
        this.showAcknowledged = event;
        this.setVizDataAccordingToAcknowledgedSelection();
    }

    private setVizDataAccordingToAcknowledgedSelection(): void {
        this.queryParamsService.dispatchUpdatedQueryParams({ acknowledged: this.showAcknowledged });
    }
}
